module.exports = __webpack_public_path__ + "static/middle-ea188c19b9fb1dc714fcbce76e608d2b.png";